import { render, staticRenderFns } from "./video-search.vue?vue&type=template&id=20d7938a&scoped=true&"
import script from "./video-search.vue?vue&type=script&lang=js&"
export * from "./video-search.vue?vue&type=script&lang=js&"
import style0 from "./video-search.vue?vue&type=style&index=0&id=20d7938a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d7938a",
  null
  
)

export default component.exports